import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import firebase from 'firebase/compat/app';
import { catchError, filter, from, map, Observable, of, switchMap, take, throwError } from 'rxjs';
import { teacherReviewLoginRoute } from '../../modules/auth/guards/role.guard';
import { AuthService } from '../../modules/auth/services/auth.service';

const interceptorPaths = [/\/api\/audit-log\/create/];

@Injectable()
export class ApiRequestInterceptorService implements HttpInterceptor {
  constructor(public auth: AuthService, private router: Router) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!interceptorPaths.find((interceptorPathRegex) => interceptorPathRegex.test(request.url))) {
      return next.handle(request);
    }
    return this.auth.afAuth.user.pipe(
      switchMap((user: firebase.User) => from(user.getIdToken())),
      map((idToken: string) =>
        request.clone({
          setHeaders: {
            'x-cdw-app-name': 'lsp',
            'x-cdw-fbauth-token': `Bearer ${idToken}`,
          },
        }),
      ),
      switchMap((updatedRequest) =>
        next.handle(updatedRequest).pipe(catchError((error) => this.handleAuthError(error))),
      ),
    );
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    if (err.status === 401 || err.status === 403) {
      return this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd),
        take(1),
        map((event) =>
          (event as NavigationEnd).urlAfterRedirects.search(teacherReviewLoginRoute) > -1 ? 'teacher' : 'none',
        ),
        switchMap((role: 'teacher' | 'none') => {
          this.auth.logout(role, false);
          // this essentially swallows the error if it is a 401 or 403
          // and handles it with a logout event
          // otherwise, it will re-throw the error
          return of(err.message);
        }),
      );
    }
    return throwError(err);
  }
}
